export const floatingConstant = {
    GET_BEFORE_LOGIN_NOTIFICATION: 'GET_BEFORE_LOGIN_NOTIFICATION',
    GET_AFTER_LOGIN_NOTIFICATION: 'GET_AFTER_LOGIN_NOTIFICATION',
    STORE_FLOATING_NOTIFICATION_ID: 'STORE_FLOATING_NOTIFICATION_ID',
    GET_CLOSE_NOTIFICATION: 'GET_CLOSE_NOTIFICATION',
};
